import React, { useRef } from "react";

import UserPic from "../../assets/images/Userpic.png";
import Pdf from "../../assets/images/PDF.png";

const UserInfoPopup = ({ user, onClose }) => {
  const handleCancelClick = (e) => {
    e.stopPropagation();
    onClose();
  };

  // const contactInfo = {
  //     image: user.image,
  //     phone: user.phone,
  // };

  // const locationInfo = {
  //     city: 'City Name',
  //     country: 'Country Name',
  // };

  // const jobInfo = {
  //     title: 'Front Desk Officer',
  //     department: 'Department Name',
  // };

  // Ref to the background overlay div
  const overlayRef = useRef(null);

  // Close the popup when clicking outside the user div
  // useEffect(() => {
  //     const handleClickOutside = (event) => {
  //         if (overlayRef.current && !overlayRef.current.contains(event.target)) {
  //             onClose();
  //         }
  //     };

  //     document.addEventListener('mousedown', handleClickOutside);

  //     return () => {
  //         document.removeEventListener('mousedown', handleClickOutside);
  //     };
  // }, [onClose]);

  const data = [
    {
      name: "Aug",
      uv: 590,
      pv: 800,
      // amt: 1400,
    },
    {
      name: "Sep",
      uv: 868,
      pv: 967,
      // amt: 1506,
    },
    {
      name: "Oct",
      uv: 1397,
      pv: 1098,
      amt: 989,
    },
    {
      name: "Nov",
      uv: 1480,
      pv: 1200,
      amt: 1228,
    },
    {
      name: "Dec",
      uv: 1520,
      pv: 1108,
      amt: 1100,
    },
    // {
    //     name: 'Page F',
    //     uv: 1400,
    //     pv: 680,
    //     amt: 1700,
    // },
  ];
  return (
    <div className="w-[20%] flex flex-col justify-center overflow-hidden absolute top-0 right-0 bg-white shadow p-4 z-[2000] rounded-md">
      <div className="flex justify-end">
        <span>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle opacity="0.05" cx="20" cy="20" r="20" fill="black" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.3139 27.1901L24.6362 17.7213C25.0342 17.2106 25.1757 16.6203 25.043 16.0192C24.9281 15.4727 24.592 14.9532 24.0879 14.559L22.8587 13.5826C21.7887 12.7315 20.4621 12.8211 19.7016 13.7976L18.8792 14.8645C18.7731 14.998 18.7996 15.195 18.9322 15.3025C18.9322 15.3025 21.0104 16.9688 21.0547 17.0046C21.1961 17.139 21.3023 17.3181 21.3288 17.5331C21.373 17.9542 21.0812 18.3483 20.6479 18.4021C20.4445 18.429 20.2499 18.3663 20.1084 18.2498L17.9241 16.5119C17.818 16.4322 17.6588 16.4492 17.5704 16.5567L12.3793 23.2754C12.0433 23.6964 11.9283 24.2428 12.0433 24.7714L12.7065 27.647C12.7419 27.7993 12.8745 27.9068 13.0337 27.9068L15.952 27.8709C16.4826 27.862 16.9779 27.6201 17.3139 27.1901ZM21.4002 26.2935H26.1589C26.6231 26.2935 27.0007 26.676 27.0007 27.1463C27.0007 27.6175 26.6231 27.9991 26.1589 27.9991H21.4002C20.936 27.9991 20.5583 27.6175 20.5583 27.1463C20.5583 26.676 20.936 26.2935 21.4002 26.2935Z"
              fill="black"
            />
          </svg>
        </span>
      </div>

      <div ref={overlayRef}>
        <div className="flex flex-col items-center border-b pb-6">
          {/* <div className="w-[79.51px] h-[70px] bg-form-background rounded-full relative">
            <img src={UserPic} alt="" />
            <div className="bg-green-400 rounded-full h-[12px] w-[12px] absolute right-2 top-0"></div>
          </div> */}
          <h2 className="text-[22px] font-semibold mb-2">
            {user.firstName} {user.lastName}
          </h2>
          <div className="flex flex-col items-center">
            <p className="w-[129.01px] font-normal text-[14px] text-navy-blue/70 text-center">
              {user.role}
            </p>
          </div>
        </div>

        {/* Contact Info Section */}
        <section className="flex flex-col pt-8 text-left">
          <h3 className="text-lg pb-8 font-semibold">Contact Info</h3>

          <div className="flex border-b pb-4 items-center gap-3 font-[Nunito] font-normal text-[16px] mb-4">
            <span>
              <svg
                width="16"
                height="15"
                viewBox="0 0 16 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.3">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9512 0C13.024 0 14.056 0.441667 14.8152 1.23417C15.5752 2.025 16 3.09167 16 4.20833V10.7917C16 13.1167 14.184 15 11.9512 15H4.048C1.8152 15 0 13.1167 0 10.7917V4.20833C0 1.88333 1.8072 0 4.048 0H11.9512ZM13.224 5.44987L13.288 5.3832C13.4792 5.14153 13.4792 4.79153 13.2792 4.54987C13.168 4.4257 13.0152 4.34987 12.856 4.3332C12.688 4.32403 12.528 4.3832 12.4072 4.49987L8.79999 7.49987C8.33599 7.9007 7.67119 7.9007 7.19999 7.49987L3.59999 4.49987C3.35119 4.3082 3.00719 4.3332 2.79999 4.5582C2.58399 4.7832 2.55999 5.14153 2.74319 5.39153L2.84799 5.49987L6.48799 8.4582C6.93599 8.82487 7.47919 9.02487 8.04799 9.02487C8.61519 9.02487 9.16799 8.82487 9.61519 8.4582L13.224 5.44987Z"
                    fill="#030229"
                  />
                </g>
              </svg>
            </span>
            <p className="text-[16px] font-normal text-navy-blue/70">
              {user.email}
            </p>
          </div>

          <div className="flex border-b pb-4 items-center gap-3 font-[Nunito] font-normal text-[16px] mb-4">
            <span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.3">
                  <path
                    d="M12.9335 9.90336C12.3961 9.78777 11.971 10.0373 11.5946 10.2551C11.2091 10.4797 10.4761 11.0743 10.056 10.9221C7.90487 10.0364 5.88171 8.15363 5.00591 5.9939C4.85155 5.56478 5.4434 4.82713 5.66626 4.4371C5.88253 4.05954 6.12686 3.63042 6.01543 3.08904C5.91472 2.60254 4.61217 0.94511 4.15158 0.491875C3.84781 0.19249 3.53662 0.0278285 3.21718 0.00121652C2.01616 -0.0503442 0.674813 1.5522 0.439562 1.93557C-0.149804 2.75306 -0.146502 3.84082 0.449467 5.15978C1.88574 8.7025 7.31798 14.049 10.874 15.5393C11.5302 15.8462 12.1303 16 12.6693 16C13.1968 16 13.6665 15.8528 14.0701 15.5609C14.3747 15.3854 16.0429 13.9775 15.9992 12.7442C15.9727 12.4298 15.8085 12.1155 15.513 11.8111C15.0631 11.3462 13.4163 10.0048 12.9335 9.90336Z"
                    fill="#030229"
                  />
                </g>
              </svg>
            </span>
            <p className="font-normal text-[14px] text-navy-blue/70">
              {user.phoneNumber}
            </p>
          </div>

          <div className="flex border-b pb-4 items-center gap-3 font-[Nunito] font-normal  mb-4">
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.3">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7ZM14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7Z"
                    fill="#030229"
                  />
                  <path
                    d="M17 15C17 14.4477 16.5523 14 16 14H8C7.44772 14 7 14.4477 7 15V21H5V15C5 13.3431 6.34315 12 8 12H16C17.6569 12 19 13.3431 19 15V21H17V15Z"
                    fill="#030229"
                  />
                </g>
              </svg>
            </span>
            <p className="font-normal text-sm text-navy-blue/70 w-[120px]">
              {user.role}
            </p>
          </div>

          <div className="flex border-b pb-4 items-center gap-3 font-[Nunito] font-normal  mb-4">
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.3">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7ZM14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7Z"
                    fill="#030229"
                  />
                  <path
                    d="M17 15C17 14.4477 16.5523 14 16 14H8C7.44772 14 7 14.4477 7 15V21H5V15C5 13.3431 6.34315 12 8 12H16C17.6569 12 19 13.3431 19 15V21H17V15Z"
                    fill="#030229"
                  />
                </g>
              </svg>
            </span>
            <p className="font-normal text-sm text-navy-blue/70 w-[60px]">
              {user.roleId}
            </p>
          </div>
        </section>
        {/* <div>
          <h3 className="font-semibold text-lg text-blue-grey/[87%]">
            User activity timeline
          </h3>
          <div className="relative">
            <div className="flex gap-2 mt-4">
              <div className="w-[18px] h-[18px] bg-floral-red/10 rounded-full flex justify-center relative">
                <div className="bg-floral-red w-3 h-3 rounded-full absolute top-[2.5px]"></div>
              </div>
              <div>
                <p className="text-sm font-semibold text-blue-grey/[87%] mb-2">
                  12 Invoices have been paid
                </p>
                <div className="absolute top-5 left-2 h-[70%] w-px bg-blue-grey/20"></div>
                <p className="font-normal text-[12px] text-blue-grey/[87%] mb-2">
                  Invoices have been paid to the company
                </p>
                <div className="flex items-center gap-3 mb-2">
                  <img src={Pdf} alt="pdf" className="w-4 h-[23px]" />
                  <p className="font-semibold text-[14px] text-blue-grey/[87%]">
                    Invoices.pdf
                  </p>
                </div>
              </div>
              <p className="text-[10px] w-[63px] font-normal text-blue-grey/[38%]">
                12 min ago
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="flex gap-2 mt-4">
              <div className="w-[18px] h-[18px] bg-floral-red/10 rounded-full flex justify-center relative">
                <div className="bg-floral-red w-3 h-3 rounded-full absolute top-[2.5px]"></div>
              </div>
              <div>
                <p className="text-sm font-semibold text-blue-grey/[87%] mb-2">
                  12 Invoices have been paid
                </p>
                <div className="absolute top-5 left-2 h-[70%] w-px bg-blue-grey/20"></div>
                <p className="font-normal text-[12px] text-blue-grey/[87%] mb-2">
                  Invoices have been paid to the company
                </p>
                <div className="flex items-center gap-3 mb-2">
                  <img src={Pdf} alt="pdf" className="w-4 h-[23px]" />
                  <p className="font-semibold text-[14px] text-blue-grey/[87%]">
                    Invoices.pdf
                  </p>
                </div>
              </div>
              <p className="text-[10px] w-[63px] font-normal text-blue-grey/[38%]">
                12 min ago
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default UserInfoPopup;
